/**
 * Entry point for public/bugreport.js.
 *
 * Built and loaded as its own bundle, ahead of the game bundle, for two reasons:
 * the console capture has to be in place before any game code runs, and the
 * report button has to survive the game bundle failing to load or throwing on
 * startup - which is exactly when we most want a report.
 *
 * Nothing in here may import game code.
 */

import { installConsoleCapture } from './consoleCapture';
import { createBugReportUi, getReportButtonRect, setReportButtonFlashing } from './bugReportUI';
import { registerContextProvider, submitBugReport } from './submitReport';
import { captureScreenshot } from './screenshot';
import { registerServerWorker } from './workerLogBridge';
import type { BugReporterApi } from './bugReporter';
import { runStartupChecks } from '../startupCheck';

installConsoleCapture();

const api: BugReporterApi = {
	registerContextProvider,
	registerServerWorker,
	submitReport: submitBugReport,
	captureScreenshot,
	setButtonFlashing: setReportButtonFlashing,
	getButtonRect: getReportButtonRect,
};
(window as any).__bugReporter = api;

function mount() {
	try {
		createBugReportUi();
	} catch (e) {
		console.error('Failed to mount bug report UI', e);
	}
}

// Must run while this script still blocks the game bundle: it decides 
// whether the machine can render at all.
try {
	runStartupChecks();
} catch (e) {
	console.error('Startup checks failed to run', e);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', mount);
} else {
	mount();
}
